export const iconFontAwesomeHumanitarianPlugCircleCheck = (
	<i className="fa-solid fa-plug-circle-check"></i>
);
